var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.4375 19.1062H33.0188C28.575 19.1062 24.9563 15.4875 24.9563 11.0437V5.625C24.9563 4.59375 24.1125 3.75 23.0813 3.75H15.1312C9.35625 3.75 4.6875 7.5 4.6875 14.1938V30.8063C4.6875 37.5 9.35625 41.25 15.1312 41.25H29.8688C35.6438 41.25 40.3125 37.5 40.3125 30.8063V20.9812C40.3125 19.95 39.4688 19.1062 38.4375 19.1062Z",
    fill: "#399E79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6254 4.14465C28.8566 3.3759 27.5254 3.9009 27.5254 4.96965V11.5134C27.5254 14.2509 29.8504 16.5197 32.6816 16.5197C34.4629 16.5384 36.9379 16.5384 39.0566 16.5384C40.1254 16.5384 40.6879 15.2822 39.9379 14.5322C37.2379 11.8134 32.4004 6.91965 29.6254 4.14465Z",
    fill: "#399E79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0243 27.6C22.4806 27.0563 21.5806 27.0563 21.0368 27.6L19.6868 28.95V21.0938C19.6868 20.325 19.0493 19.6875 18.2805 19.6875C17.5117 19.6875 16.8742 20.325 16.8742 21.0938V28.95L15.5242 27.6C14.9805 27.0563 14.0805 27.0563 13.5367 27.6C12.993 28.1438 12.993 29.0437 13.5367 29.5875L17.2867 33.3375C17.3055 33.3563 17.3242 33.3562 17.3242 33.375C17.4367 33.4875 17.5867 33.5813 17.7367 33.6563C17.9242 33.7125 18.093 33.75 18.2805 33.75C18.468 33.75 18.6367 33.7125 18.8056 33.6375C18.9743 33.5625 19.1243 33.4688 19.2743 33.3375L23.0243 29.5875C23.5681 29.0437 23.5681 28.1438 23.0243 27.6Z",
    fill: "#399E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.6a66f973cb97c8ed98e697c5e12ac163.svg";
export { ForwardRef as ReactComponent };